/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_Step2Inputs */

const en_gc_resources_guide_start_step2 = /** @type {(inputs: Gc_Resources_Guide_Start_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a worksheet tab. Click a cell and type a value, or double-click a cell to edit its current content.`)
};

const zh_gc_resources_guide_start_step2 = /** @type {(inputs: Gc_Resources_Guide_Start_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择工作表标签。点击单元格输入数值，或双击单元格编辑已有内容。`)
};

/**
* | output |
* | --- |
* | "Choose a worksheet tab. Click a cell and type a value, or double-click a cell to edit its current content." |
*
* @param {Gc_Resources_Guide_Start_Step2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_step2 = /** @type {((inputs?: Gc_Resources_Guide_Start_Step2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_Step2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_step2(inputs)
	return zh_gc_resources_guide_start_step2(inputs)
});
export { gc_resources_guide_start_step2 as "gc.resources.guide.start.step2" }